﻿import { getLiveData } from "./API/LiveData/LiveData";
import { LiveDataSet } from "./API/LiveData/LiveDataSet";
import { ILiveDataListener } from "./ILiveDataListener";

export class LiveDataManager {
    private interval = 30000;

    public latestData: LiveDataSet = null;

    private listeners: ILiveDataListener[] = [];

    public addListener(listener: ILiveDataListener): void {
        this.listeners.push(listener);
    }

    public start(): void {
        this.cancelled = false;
        this.refresh(true);
    }

    public stop(): void {
        this.cancelled = true;
    }

    private cancelled: boolean;

    private timeoutWaiting: boolean = false;

    public refresh(repeat = false): void {
        getLiveData((err: any, data: LiveDataSet) => {
            if (this.cancelled) {
                return;
            }

            if (data !== null) {
                this.latestData = data;
            }

            this.listeners.forEach((listener: ILiveDataListener) => {
                try {
                    listener.liveDataChanged(this.latestData, null);
                } catch (error) {}
            });

            if (repeat && !this.timeoutWaiting) {
                window.setTimeout(() => {
                    this.timeoutWaiting = false;
                    this.refresh(true);
                }, this.interval);
                this.timeoutWaiting = true;
            }
        });
    }
}